import { render, staticRenderFns } from "./IconArrowheadTop.vue?vue&type=template&id=8b26fd40&"
import script from "./IconArrowheadTop.vue?vue&type=script&lang=js&"
export * from "./IconArrowheadTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports